import type { GridOption } from 'echarts/types/dist/shared';

import { ECHARTS_GRID_OPTIONS } from '../constants';

export const getEChartsGridOptionsByTitle = (title?: string): GridOption => {
  return {
    ...ECHARTS_GRID_OPTIONS,
    top: title ? 30 : ECHARTS_GRID_OPTIONS.top,
  };
};
